var App = App || {};

App.OffcanvasLogin = (function ($) {
    'use strict';

    function Events() {

        const primary = $(".offcanvas-login#Offcanvas_Login");
        const secondary = primary.siblings(".offcanvas-login");
        const back = secondary.find(".offcanvas-login-back button");

        primary.on("show.bs.offcanvas", function () {
            Ctas($(this));
        });

        secondary.on("show.bs.offcanvas", function () {
            primary.offcanvas("hide");
            Ctas($(this));
        });

        back.on("click", function () {
            const offcanvas = $(this).parents(".offcanvas");
            offcanvas.offcanvas("hide");
            primary.offcanvas("show");
        });
    }

    function Ctas(offcanvas) {

        offcanvas.find(".offcanvas-login-ctas").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".offcanvas-login-cta", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

    }

    return {
        Events: Events,
        Ctas: Ctas
    };

})(jQuery);